import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

import {
  setBudgetYear,
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle,
  setFilterSquads,
  setFilterCluster,
  setFilterCollaborators,
  setClientsBudgetState
} from "actions";
import {
  fetchNonCategorizedTaskTypeCount,
  fetchParameterSettings,
  getUpdatedBudget,
  fetchBudgetYears
} from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";

import ClientVue from "./ClientVue";

class ClientsVuePage extends Component {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen };
  }

  componentDidMount() {
    const { dispatch, subMenuDirection, year } = this.props;

    dispatch(setCurrentNavPage("CLIENTS_LIST_PAGE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(false));

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });

    year === null && dispatch(setBudgetYear(moment().year()));
    dispatch(getUpdatedBudget(moment().year()));
    dispatch(fetchBudgetYears());
    dispatch(fetchNonCategorizedTaskTypeCount());
    dispatch(fetchParameterSettings(year));
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
    dispatch(setFilterCollaborators([]));
    dispatch(setFilterCollaborators([]));
    dispatch(setFilterSquads([]));
    dispatch(setFilterCluster([]));
    dispatch(setClientsBudgetState([]));
  }

  render() {
    return (
      <div className={`page-content`}>
        <ClientVue uen={this.state.organizationUen} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  year: state.clients.list.year,
  organization: state.timeSheet.organization,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(ClientsVuePage);



// WEBPACK FOOTER //
// ./src/components/ClientsList/ClientsVuePage.js